import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useMembers = () =>
  useStore(store => store.listMembers)
